import { EMAIL_CONSTRAINTS, EMAIL_REGEX } from './regex'

/**
 * Email валидация - React Hook Form правила
 */

/**
 * Правила валидации для обязательного email (React Hook Form)
 */
export const emailRules = {
	required: 'Укажите email',
	pattern: {
		value: EMAIL_REGEX,
		message: 'Некорректный email'
	},
	minLength: {
		value: EMAIL_CONSTRAINTS.MIN_LENGTH,
		message: `Необходимо минимум ${EMAIL_CONSTRAINTS.MIN_LENGTH} символов`
	},
	maxLength: {
		value: EMAIL_CONSTRAINTS.MAX_LENGTH,
		message: `Максимум ${EMAIL_CONSTRAINTS.MAX_LENGTH} символа`
	}
} as const

/**
 * Правила валидации для опционального email (React Hook Form)
 */
export const emailRulesOptional = {
	pattern: {
		value: EMAIL_REGEX,
		message: 'Некорректный email'
	},
	minLength: {
		value: EMAIL_CONSTRAINTS.MIN_LENGTH,
		message: `Необходимо минимум ${EMAIL_CONSTRAINTS.MIN_LENGTH} символов`
	},
	maxLength: {
		value: EMAIL_CONSTRAINTS.MAX_LENGTH,
		message: `Максимум ${EMAIL_CONSTRAINTS.MAX_LENGTH} символа`
	}
} as const
